
export default {
  data() {
    return {
      filters: {
        seasons: {
          seasons: [],
          selectedSeason: ``,
        },
        taxonomy: {
          players: false,
          team: true,
        },
      },
    };
  },
  computed: {
    selectedSeason() {
      return (
        this.filters?.seasons?.selectedSeason
      );
    },
    selectedTaxonomy() {
      return Object.entries(this.filters.taxonomy).find(
        (taxonomy) => taxonomy[1] === true
      )[0];
    },
  },
  watch: {
    selectedSeason: {
      immediate: true,
      handler(selectedSeason) {
        this.$emit(`selectedSeason`, selectedSeason);
      },
    },
    selectedTaxonomy: {
      immediate: true,
      handler(selectedTaxonomy) {
        this.$emit(`selectedTaxonomy`, selectedTaxonomy);
      },
    },
  },
  async created() {
    const calendarPeriods =
      await this.getCalendarPeriodsWithSeasonAndCompetitionData();
    const filterCalendarPeriodsWithCriteria =
      this.objectDeepLookupByPathAdvanced({
        expectedValue: `Scottish Premiership`,
      });

    const convertedCalendarPeriodsIntoScottishPremiershipSeasons =
      calendarPeriods?.data
        ?.map((calendarPeriod) => {
          return filterCalendarPeriodsWithCriteria(
            calendarPeriod,
            `seasons.competition.name`
          );
        })
        .map((season) => {
          return {
            name: `${season?.competition?.name} ${season?.name}`,
            id: season?.id,
          };
        })
        .sort((a, b) => b.name.localeCompare(a.name));

    this.$nextTick(() => {
      this.filters.seasons.seasons =
        convertedCalendarPeriodsIntoScottishPremiershipSeasons;
      this.filters.seasons.selectedSeason =
        convertedCalendarPeriodsIntoScottishPremiershipSeasons[0];
    });
  },
  methods: {
    // INTERFACES:
    // ABSTRACTION BARRIER:
    getCalendarPeriodsWithSeasonAndCompetitionData(id) {
      return this.asyncResponseHandler(
        async () =>
          await this.$getStats(`calendarPeriod${id ? `/${id}` : ``}`, {
            include: `seasons.competition`,
          })
      );
    },
  },
};
